<template>
  <div>
    <vue-header/>
    <div class="wd-container" style="margin-top: 15px;text-align:left;">
      <div class="container">
        <loading :active.sync="isLoading"
          :can-cancel="false"
          :width="50"
          :height="50"
          :is-full-page="false">
        </loading>

        <b-card no-body dark>
          <b-card-text class="p-2" v-if="profile.credentials.length > 0">
            <p class="mb-2">
              {{ dateFormatFull(profile.credentials[0].created_at) }}
              <b>(CURRENT)</b>
            </p>

            <b-table
              :items="profile.credentials"
              :fields="fields"
              class="table-child cred-table mb-0"
              thead-class="cred-thead"
              :borderless="true"
              small
              responsive
            >
              <!-- Credentials: checkbox + description -->
              <template #cell(description)="data">
                <b-form-checkbox
                  :value="data.item.id"
                  :checked="data.item.id"
                  disabled
                  class="d-inline-flex align-items-center"
                >
                  {{ data.item.description }}
                </b-form-checkbox>
              </template>

              <!-- Responsive header: full label at xl+, short below -->
              <template #head(expiry_date)>
                <span class="d-none d-xl-inline">Expiration Date</span>
                <span class="d-xl-none">Exp. Date</span>
              </template>

              <!-- Expiration Date: read-only text input + calendar icon -->
              <template #cell(expiry_date)="data">
                <b-input-group class="cred-date-input-group">
                  <b-form-input
                    :value="data.item.expiry_date"
                    disabled
                    placeholder="—"
                  />
                  
                </b-input-group>
              </template>

              <!-- View: eye icon -->
              <template #cell(view)="data">
                <b-button
                  v-if="data.item.document"
                  variant="link"
                  class="p-0"
                  :disabled="viewingDocId === data.item.id"
                  @click="viewDocument(data.item)"
                >
                  <i
                    v-if="viewingDocId === data.item.id"
                    class="fa fa-hourglass-half fa-spin text-success"
                    style="font-size:1.2rem;"
                  ></i>
                  <i
                    v-else
                    class="fa fa-eye text-success"
                    style="font-size:1.2rem;"
                  ></i>
                </b-button>
                <i
                  v-else
                  class="fa fa-eye text-muted"
                  style="font-size:1.2rem; opacity:0.4;"
                ></i>
              </template>
            </b-table>
          </b-card-text>

          <b-card-text class="p-2" v-else>
            <p>You don't have any assigned credentials. Please contact administrator</p>
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import CommonConstants from '@/constants/constants.js'
import moment from 'moment'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: 'UserCredentials',
  components: { Loading },
  data() {
    return {
      constants: CommonConstants,
      header: {},
      moment: moment,
      profile: { credentials: [] },
      isLoading: true,
      viewingDocId: null,
      fields: [
        {
          key: 'description',
          label: 'Credentials',
          thStyle: { width: '50%', minWidth: '100px' },
          tdClass: 'align-middle'
        },
        {
          key: 'expiry_date',
          label: 'Exp. Date',
          thStyle: { width: '37%', minWidth: '110px', whiteSpace: 'nowrap' },
          tdClass: 'align-middle'
        },
        {
          key: 'view',
          label: 'File',
          thStyle: { width: '13%', minWidth: '36px', textAlign: 'center' },
          tdClass: 'text-center align-middle'
        }
      ]
    }
  },
  mounted: function () {
    let self = this;
    self.header = {
      'Content-type': 'application/json',
      'token': localStorage.getItem('token')
    }
    self.getUserProfile()
  },
  methods: {
    dateFormatFull(date) {
      return moment(date).format('MMM DD, YYYY, h:mm A');
    },
    getUserProfile: function () {
      let self = this
      self.isLoading = true;
      self.profile.credentials = [];
      axios.get(self.constants.api_url + 'users/credential/search/' + self.$route.params.id, { headers: self.header })
        .then(function (response) {
          if (response.data.flag) {
            self.profile.credentials = response.data.data;
            self.isLoading = false;
          } else {
            self.$toasted.show(response.data.message, self.errorToast)
            self.$router.push('/AccessControl');
          }
        })
        .catch(function (error) {
          self.$toasted.show(error, self.errorToast)
        })
        .finally(function () {
          self.isLoading = false;
        })
    },
    viewDocument(item) {
      let self = this;
      self.viewingDocId = item.id;
      axios.get(
        self.constants.api_url + 'user/credential-document/preview/' + item.id,
        { headers: self.header }
      ).then(function (response) {
        if (response.data.url) {
          self.viewingDocId = null;
          var win = window.open(response.data.url, '_blank');
          if (!win) {
            self.$toasted.show('Popup blocked. Please allow popups to view the document.', self.errorToast);
          }
        } else {
          self.viewingDocId = null;
        }
      }).catch(function (error) {
        self.viewingDocId = null;
        self.$toasted.show('Unable to load document.', self.errorToast);
      });
    }
  }
}
</script>

<style>
.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
  color: #fff;
  background-color: #17a2b8 !important;
}
</style>
<style>
.table-ellipsis {
  table-layout: fixed;
}
.b-rating.disabled, .b-rating:disabled {
  background-color: transparent !important;
  color: #ffc107 !important;
}
</style>
<style scoped>
/* ── Base table cell padding ─────────────────────────────── */
.cred-table td, .cred-table th {
  padding: 6px 6px !important;
  border: none !important;
}

/* ── Header styling ──────────────────────────────────────── */
.cred-thead th {
  font-size: 0.82rem;
  font-weight: 600;
  color: #6c757d;
  border-bottom: 1px solid #dee2e6 !important;
  white-space: nowrap;
}

/* ── Date input group: fill cell width ───────────────────── */
.cred-date-input-group {
  width: 100%;
  max-width: 120px;
}
.cred-date-input-group .input-group-text {
  padding: 0.25rem 0.4rem;
}
.cred-date-input-group .form-control {
  min-width: 0;
  font-size: 0.8rem;
}

/* ── Disabled input appearance ───────────────────────────── */
.cred-table .input-group input:disabled {
  background-color: #fff !important;
  color: #495057;
}
.cred-table .input-group-text {
  background-color: #fff !important;
}

/* ── View button ─────────────────────────────────────────── */
.cred-table .btn-link:focus,
.cred-table .btn-link:active {
  outline: none !important;
  box-shadow: none !important;
}
.cred-table .btn-link {
  transition: transform 0.1s ease, opacity 0.1s ease;
}
.cred-table .btn-link:active {
  transform: scale(0.85);
  opacity: 0.7;
}
.cred-table .btn-link:hover .fa-eye {
  color: #157347 !important;
}

/* ── Mobile overrides (<480px) ───────────────────────────── */
@media (max-width: 480px) {
  .cred-table td, .cred-table th {
    padding: 5px 4px !important;
  }
  .cred-date-input-group {
    width: 100%;
    max-width: 100px;
  }
  .cred-date-input-group .form-control {
    font-size: 0.75rem;
    padding: 0.25rem 0.3rem;
  }
  .cred-date-input-group .input-group-text {
    padding: 0.25rem 0.35rem;
  }
}
</style>
